import { Eye } from "lucide-react";
import React, { memo, useCallback, useEffect, useMemo } from "react";

import { Badge } from "../../../../components/ui/badge";
import { Button } from "../../../../components/ui/button";
import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuItem,
	DropdownMenuTrigger,
} from "../../../../components/ui/dropdown-menu";
import { TableCell, TableRow } from "../../../../components/ui/table";
import { cn } from "../../../../handlers/cn.utils";
import { JobApplicationState, JobApplicationStatus } from "../../../../handlers/enums";
import { formatAPIDate } from "../../../../handlers/utilityFunctions";

function ApplicantsTableRow({ data, openJobDetails, handleStatusChange, getStatusColor, selected, onSelect }) {
	const [jobApplication, setJobApplication] = React.useState(data);

	const status = useMemo(() => {
		const stat = jobApplication.stages[jobApplication.stages.length - 1];
		return stat?.status;
	}, [jobApplication.stages]);

	// Optimized click handlers
	const handleRowClick = useCallback(() => {
		onSelect?.();
	}, [onSelect]);

	const handleStatusChange_Internal = useCallback(
		(newStatus) => {
			// optimistic update
			const stagesArray = [
				...jobApplication.stages,
				{
					status: newStatus,
					notes: null,
					state: JobApplicationState.NOT_STARTED,
				},
			];

			setJobApplication((prev) => ({ ...prev, stages: stagesArray }));

			handleStatusChange(jobApplication._id, newStatus, status);
		},
		[jobApplication._id, jobApplication.stages, handleStatusChange, status],
	);

	const handleViewClick = useCallback(() => {
		openJobDetails(jobApplication);
	}, [openJobDetails, jobApplication]);

	// Sync local state with prop data when it changes (e.g., after re-fetch)
	useEffect(() => {
		setJobApplication(data);
	}, [data]);

	return (
		<TableRow className={cn("cursor-pointer group", selected && "bg-blue-50")} onClick={handleRowClick}>
			{/*<TableCell className="w-12" onClick={(e) => e.stopPropagation()}>*/}
			{/*	/!*<Checkbox name={jobApplication._id} id={jobApplication._id} checked={selected} onCheckedChange={onSelect} />*!/*/}
			{/*</TableCell>*/}
			<TableCell className="font-medium flex items-center gap-2">
				<div>
					<p className="text-xs text-gray-500">{jobApplication.companyName}</p>
					<p className="text-sm">{jobApplication.jobTitle}</p>
				</div>
			</TableCell>
			{/*<TableCell>{job.location}</TableCell>*/}
			<TableCell>{jobApplication.email}</TableCell>
			<TableCell onClick={(e) => e.stopPropagation()}>
				<DropdownMenu>
					<DropdownMenuTrigger asChild>
						<Badge variant="default" className={`text-xs py-1 px-2 rounded cursor-pointer ${getStatusColor(status)}`}>
							{status.replace(/_/g, " ")}
						</Badge>
					</DropdownMenuTrigger>
					<DropdownMenuContent style={{ backgroundColor: "white" }}>
						{Object.values(JobApplicationStatus).map((status) => (
							<DropdownMenuItem
								style={{ cursor: "pointer" }}
								key={status}
								onClick={() => handleStatusChange_Internal(status)}
							>
								{status.replace(/_/g, " ")}
							</DropdownMenuItem>
						))}
					</DropdownMenuContent>
				</DropdownMenu>
			</TableCell>
			<TableCell className="text-nowrap">{formatAPIDate("MMM D, YYYY", jobApplication.createdAt)}</TableCell>
			<TableCell className="text-right" onClick={(e) => e.stopPropagation()}>
				<Button variant="outline" size="sm" onClick={handleViewClick}>
					<Eye size={12} />
				</Button>
			</TableCell>
		</TableRow>
	);
}

export default memo(ApplicantsTableRow);
